import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { PageService } from '../providers/page/page.service';
import { Meta, Title } from '@angular/platform-browser';

@Component({
	selector: 'app-detail-master',
	templateUrl: './detail-master.component.html',
	styleUrls: ['./detail-master.component.scss'],
})
export class DetailMasterComponent {
	baseUrl: any;
	Url: any;

	constructor(
		private pageservice: PageService,
		private metaTagService: Meta,
		private titleService: Title
	) {
		this.baseUrl = environment.baseUrl + '/assets';
		this.Url = environment.baseUrl;
	}
	imageData: any = [
		{
			albumId: 1,
			id: 1,
			thumbnailUrl: 'https://via.placeholder.com/150/92c952',
			title: 'accusamus beatae ad facilis cum similique qui sunt',
			url: environment.baseUrl + '/assets/images/projects/miniaar/ima-01.png',
		},
		{
			albumId: 1,
			id: 2,
			thumbnailUrl: 'https://via.placeholder.com/150/92c952',
			title: 'accusamus beatae ad facilis cum similique qui sunt',
			url: environment.baseUrl + '/assets/images/projects/miniaar/ima-02.png',
		},
		{
			albumId: 1,
			id: 3,
			thumbnailUrl: 'https://via.placeholder.com/150/92c952',
			title: 'accusamus beatae ad facilis cum similique qui sunt',
			url: environment.baseUrl + '/assets/images/projects/miniaar/ima-03.png',
		},
		{
			albumId: 1,
			id: 4,
			thumbnailUrl: 'https://via.placeholder.com/150/92c952',
			title: 'accusamus beatae ad facilis cum similique qui sunt',
			url: environment.baseUrl + '/assets/images/projects/miniaar/ima-04.png',
		},
		{
			albumId: 1,
			id: 5,
			thumbnailUrl: 'https://via.placeholder.com/150/92c952',
			title: 'accusamus beatae ad facilis cum similique qui sunt',
			url: environment.baseUrl + '/assets/images/projects/miniaar/ima-05.png',
		},
		{
			albumId: 1,
			id: 6,
			thumbnailUrl: 'https://via.placeholder.com/150/92c952',
			title: 'accusamus beatae ad facilis cum similique qui sunt',
			url: environment.baseUrl + '/assets/images/projects/miniaar/ima-06.png',
		},
	];
	desktopslider: OwlOptions = {
		// loop: true,
		// rewind: true,
		// autoplay: true,
		autoplayTimeout: 2000,
		center: false,
		// mouseDrag:true,
		// dots: false,
		margin: 10,
		// autoHeight: true,
		// autoWidth: true,
		loop: true,
		autoplay: true,
		mouseDrag: true,
		touchDrag: true,
		pullDrag: true,
		dots: false,
		// animateOut: 'fadeOut',
		// animateIn: 'fadeIn',
		// stagePadding: 180,
		// smartSpeed: 1,
		responsive: {
			0: {
				items: 1,
			},
			600: {
				items: 2,
			},
			1000: {
				items: 3,
			},
		},
	};
	desktopslider1: OwlOptions = {
		autoplayTimeout: 2500,
		center: false,
		margin: 10,
		loop: true,
		autoplay: true,
		mouseDrag: true,
		touchDrag: true,
		pullDrag: true,
		dots: false,
		responsive: {
			0: {
				items: 1,
			},
			600: {
				items: 2,
			},
			1000: {
				items: 3,
			},
		},
	};
	desktopslider2: OwlOptions = {
		autoplayTimeout: 3000,
		center: false,
		margin: 10,
		loop: true,
		autoplay: true,
		mouseDrag: true,
		touchDrag: true,
		pullDrag: true,
		dots: false,
		responsive: {
			0: {
				items: 1,
			},
			600: {
				items: 2,
			},
			1000: {
				items: 3,
			},
		},
	};
	ngOnInit(): void {
		setTimeout(() => {
			window.scroll({
				top: 0,
				left: 0,
				behavior: 'smooth',
			});
		}, 500);
		this.get_PageMeta();
	}

	get_PageMeta() {
		let obj = { pageName: 'detail-master' };
		this.pageservice.getpageWithName(obj).subscribe((response) => {
			if (response.body.code == 200) {
				if (response.body.result) {
					this.titleService.setTitle(response?.body.result.meta_title);
					// this.metaTagService.addTags([
					//     { name: 'description', content: response?.body.result.meta_description },
					//     { name: 'keywords', content: response?.body.result.meta_keywords },
					// ]);
					this.metaTagService.updateTag({
						name: 'description',
						content: response?.body.result.meta_description,
					});
					this.metaTagService.updateTag({
						name: 'keywords',
						content: response?.body.result.meta_keywords,
					});
					this.metaTagService.updateTag({
						rel: 'canonical',
						href: 'https://www.pixtar.ae/projects',
					});
				}
			} else if (response.body.code == 400) {
			} else {
			}
		});
	}
}
